import { render, staticRenderFns } from "./PdvClosedMotoboy.vue?vue&type=template&id=236fcaaa"
import script from "./PdvClosedMotoboy.vue?vue&type=script&lang=js"
export * from "./PdvClosedMotoboy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports